<template>
  <div class="panel-container">
    <IntegrationConfigCard
      v-bind="$props"
    />
    <TallyFormCard
      form-url="https://hello.datapeople.io/workday"
    />
  </div>
</template>

<script>
import TallyFormCard from '@/components/settings/integrations/TallyFormCard.vue';
import IntegrationConfigCard from '@/components/settings/integrations/IntegrationConfigCard.vue';

export default {
  name: 'WorkdaySettings',
  components: {
    TallyFormCard,
    IntegrationConfigCard,
  },
  props: {
    atsName: { type: String, default: '' },
    guidance: { type: String, default: '' },
    logoUrl: { type: String, default: '' },
  },
};
</script>
